import classNames from 'classnames'
import Tooltip from 'rc-tooltip'
import { forwardRef } from 'react'
import { MdInfoOutline } from 'react-icons/md'

import type { PropsWithChildren, ReactElement, ReactNode } from 'react'

import './styles.scss'

export interface Props {
  className?: string
  title?: ReactNode
  tooltipOverlay?: ReactNode
}

const Section = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ children, className, title, tooltipOverlay }, ref): ReactElement => {
    return (
      <div className={classNames('section-layout-component', className)} ref={ref}>
        {title ? (
          <div className="group-title">
            <SectionTitle>{title}</SectionTitle>
            {tooltipOverlay ? (
              <Tooltip overlay={tooltipOverlay} placement="top" trigger="hover">
                <div className="tooltip">
                  <MdInfoOutline className="tooltip-icon" size={15} />
                </div>
              </Tooltip>
            ) : null}
          </div>
        ) : null}
        {children}
      </div>
    )
  }
)

Section.displayName = 'Section'

export const SectionTitle = ({ children }: PropsWithChildren): ReactElement => {
  return <div className="section-title-component">{children}</div>
}

export default Section
